import { styled } from '@mui/material/styles';
export const ColorSvgIcon = styled('div')(({ theme, ...props }) => ({
    color: theme.palette.mode === 'dark' ? '#f0f0f0' : '#474747',
}));
